import React from "react";

const MyTitle = () => {
  return (
    <div className="content d-flex justify-content-center align-items-center" style={{ backgroundColor: 'transparent', paddingLeft: '5%', paddingRight: '5%' }}>
      <div className="container" style={{ paddingTop: '50px', paddingBottom: '50px' }}>
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="container">
              <div className="row justify-content-center align-items-center">
                <div className="col-12 col-md-8 d-flex flex-column align-items-center">
                  <div style={{
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    background: 'linear-gradient(180deg, rgb(40, 200, 248) 0%, rgb(1, 98, 219) 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                    fontWeight: 700,
                    lineHeight: '23px',
                    fontSize: '23px',
                    marginLeft: '0.95px',
                    minWidth: '39px',
                    textAlign: 'center',
                    textFillColor: 'transparent',
                    whiteSpace: 'nowrap'
                  }}>
                    LIST
                  </div>
                  <div style={{
                    letterSpacing: '0',
                    lineHeight: '30px',
                    marginRight: '4px',
                    minWidth: '266px',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    color: '#192b43',
                    fontSize: '30px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    marginTop: '16px',
                    marginBottom: '30px'
                  }}>
                    案件一覧
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTitle;

